const translations: Record<string, string> = {
  "ak_tr_mwh": "МВт·год",
  "ak_tr_uah_mwh_actual": "грн · {{n}} МВт·год факт.",
  "ak_tr_d": "д",
  "ak_tr_dam_weighted": "РДН weighted",
  "ak_tr_idm_weighted": "ВДР weighted",
  "ak_tr_dam_volume": "РДН обсяг",
  "ak_tr_dam_price": "РДН ціна",
  "ak_tr_idm_price": "ВДР ціна",
  "ak_tr_oree_dam_weighted": "OREE РДН weighted",
  "ak_tr_oree_idm_weighted": "OREE ВДР weighted",
  "ak_tr_ueex_base_realized": "УЕБ BASE realized",
  "ak_tr_actual_generation_mwh": "Факт. вироб., МВт·год",
  "ak_tr_potential_revenue_uah_dam_actual": "Потенц. виторг, грн (DAM × факт.)",
  "ak_tr_7d_avg": "7д сер.:",
  "ak_tr_mwh_actual": "{{n}} МВт·год факт.",
  "ak_tr_days": "{{n}} діб",
  "ak_tr_dam_uah_mwh": "РДН, грн/МВт·год",
  "ak_tr_idm_uah_mwh": "ВДР, грн/МВт·год",
  "ak_tr_oree_dam": "ОРЕ РДН",
  "ak_tr_oree_idm": "ОРЕ ВДР",
  "ak_tr_actual_generation_mwh_2": "Факт. вироблення, МВт·год",
  "ak_tr_potential_revenue_uah": "Потенц. виторг, грн",
  "ak_tr_loading": "Завантаження…",
  "ak_tr_dam": "РДН",
  "ak_tr_idm": "ВДР",
  "ak_tr_ueex_base": "УЕБ BASE",
  "ak_tr_actual_generation": "Факт. вироблення",
  "ak_tr_potential_revenue": "Потенц. виторг",
  "ak_tr_uah": "грн",
};

export default translations;
